import { useContext } from 'react';

import FilingProgressContext, { type IFilingProgressContext } from './FilingProgressContext';

/** Consume the global filing progress context. */
const useFilingProgressContext = (): IFilingProgressContext => useContext(FilingProgressContext);

export default useFilingProgressContext;
